import { legacy_createStore as createStore, applyMiddleware } from "redux";
import rootReducer from "../reducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { thunk } from "redux-thunk";
import Config from "../../utilities/config";
import { ACTION_TYPE } from "../action/type";

//redux logger
const logger = (store) => (next) => (action) => {
  // Config.logGeneral && console.info("dispatching", action);
  let result = next(action);
  // config.logGeneral && console.log("next state", store.getState());
  Config.logGeneral && console.groupEnd();
  return result;
};

// Middleware: Redux Persist Config
const persistConfig = {
  key: "root",
  storage: storage,
};

// Middleware: Redux Persist Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Redux: Store
const store = createStore(persistedReducer, applyMiddleware(thunk, logger));

let persistor = persistStore(store);

export { store, persistor };
